import translations from './translations'

translations.add('pt', {
    invalidCvv: 'Insira um código de segurança válido',
    pleaseEnter: 'Insira:',
    backCardList: 'Voltar à lista de cartões'
})
